import { render } from "./SortTableAbsenceStatusComponent.vue?vue&type=template&id=7e6082de&scoped=true"
import script from "./SortTableAbsenceStatusComponent.vue?vue&type=script&lang=js"
export * from "./SortTableAbsenceStatusComponent.vue?vue&type=script&lang=js"

import "./SortTableAbsenceStatusComponent.vue?vue&type=style&index=0&id=7e6082de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6082de"]])

export default __exports__